import en from './locales/en_US'
import es from './locales/es_ES'

const AppLocale = {
  'en-US': { locale: 'en-US', messages: { ...en } },
  'es-ES': { locale: 'es-ES', messages: { ...es } },
}

export default AppLocale
